/* eslint-disable */
import PropTypes from "prop-types";
import screenPropTypes from "../screens/screen-prop-types";

const button = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  onClick: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
  text: PropTypes.string,
  className: PropTypes.string
};

const select = {
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  selectedOption: PropTypes.string,
  name: PropTypes.string,
  fieldAttributes: PropTypes.object,
  hideSelectedOptions: PropTypes.bool
};

const fieldWrapper = {
  field: PropTypes.object.isRequired
};

const textField = {
  maskingAttributes: PropTypes.object.isRequired,
  fieldAttributes: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  updateValue: PropTypes.func.isRequired
};

const modernizedInputField = {
  maskingAttributes: PropTypes.object.isRequired,
  fieldAttributes: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  updateValue: PropTypes.func.isRequired
};

const label = {
  text: PropTypes.node,
  name: PropTypes.string,
  appData: PropTypes.objectOf(PropTypes.object),
  srLabel: PropTypes.string
};

const modernizedLabel = {
  text: PropTypes.node,
  name: PropTypes.string,
  appData: PropTypes.objectOf(PropTypes.object),
  srLabel: PropTypes.string
};

const text = {
  ariaLabel: PropTypes.string,
  label: PropTypes.node,
  name: PropTypes.string
};

const title = {
  title: PropTypes.string.isRequired
};

const description = {
  description: PropTypes.string.isRequired
};

const listItem = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  lastOfKind: PropTypes.bool
};

const address = {
  name: PropTypes.string.isRequired,
  address_line1: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  zipCode: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

const provider = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  acceptsVideo: PropTypes.bool.isRequired,
  graySubtitle: PropTypes.string.isRequired,
  profileImage: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};

const providerControl = {
  provider: PropTypes.shape({
    detail_data: PropTypes.shape({
      bio: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      role: PropTypes.string.isRequired,
      gender: PropTypes.string.isRequired,
      languages: PropTypes.string.isRequired,
      providerSpecialties: PropTypes.string.isRequired,
      providerCredentials: PropTypes.string.isRequired,
      slotAvailability: PropTypes.string.isRequired,
      specialTraining: PropTypes.string.isRequired,
      websiteUrl: PropTypes.string.isRequired,
      vpcpLabel: PropTypes.string.isRequired,
      vpcpTooltip: PropTypes.string.isRequired,
      earliestAvailability: PropTypes.string.isRequired,
      unavailabilities: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  components: PropTypes.shape({
    Tooltip: PropTypes.func
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
  onViewProfile: PropTypes.func.isRequired,
  screenName: PropTypes.string.isRequired
};

const vpcpInfo = {
  components: PropTypes.shape({
    Tooltip: PropTypes.func
  }).isRequired,
  label: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired
};

const image = {
  image: PropTypes.string.isRequired
};

const webImage = {
  url: PropTypes.string.isRequired,
  size: PropTypes.number,
  align: PropTypes.string
};

const input = {
  name: PropTypes.string,
  value: PropTypes.string,
  onKeyUp: PropTypes.func,
  ariaLabel: PropTypes.string
};

const slider = {
  handleChange: PropTypes.func.isRequired,
  field: PropTypes.object.isRequired,
  isRadioGroup: PropTypes.bool,
  label: PropTypes.string
};

const htmlText = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  params: PropTypes.string
};

const switchControl = {
  checked: PropTypes.bool,
  labelText: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

const icon = {
  showIcon: PropTypes.bool.isRequired,
  src: PropTypes.any.isRequired,
  stylesObject: PropTypes.object
};

const expansionPanel = {
  showBody: PropTypes.bool.isRequired,
  subtitle: PropTypes.string,
  inlineHeader: PropTypes.bool,
  header: PropTypes.string,
  toggleExpansion: PropTypes.func.isRequired,
  body: PropTypes.any.isRequired
};

const expansionMessage = {
  expanded: PropTypes.bool.isRequired,
  title: PropTypes.string,
  updatedAt: PropTypes.string,
  shortDescription: PropTypes.string,
  toggleExpansion: PropTypes.func.isRequired,
  body: PropTypes.any.isRequired
};

const checkbox = {
  name: PropTypes.string,
  label: PropTypes.node,
  style: PropTypes.object,
  onChange: PropTypes.func.isRequired
};

const progressBar = {
  value: PropTypes.number.isRequired
};

const datePicker = {
  inline: PropTypes.bool,
  value: PropTypes.instanceOf(Date).isRequired,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  onChange: PropTypes.func.isRequired,
  mobile: PropTypes.bool,
  invalid: PropTypes.bool,
  placeholderText: PropTypes.string,
  components: PropTypes.shape({ Input: PropTypes.objectOf(PropTypes.object) })
    .isRequired,
  includeDates: PropTypes.object.isRequired,
  isClearable: PropTypes.bool, // Has no idea what this prop using for
  label: PropTypes.string,
  usePulseStyles: PropTypes.bool,
  showCalendarIcon: PropTypes.bool,
  appData: PropTypes.object.isRequired,
  inputAriaLabel: PropTypes.string,
  name: PropTypes.string
};

const inlineDatePicker = {
  dayPickerProps: PropTypes.object.isRequired,
  wrapperClassName: PropTypes.string
};

const popperDatePicker = {
  dayPickerProps: PropTypes.object.isRequired,
  wrapperClassName: PropTypes.string,
  value: PropTypes.string.isRequired,
  translations: PropTypes.object.isRequired,
  placeholderText: PropTypes.string,
  Input: PropTypes.object.isRequired,
  label: PropTypes.string,
  usePulseStyles: PropTypes.bool,
  showCalendarIcon: PropTypes.bool,
  inputAriaLabel: PropTypes.string,
  name: PropTypes.string
};

const timePicker = {
  value: PropTypes.instanceOf(Date).isRequired,
  minTime: PropTypes.instanceOf(Date),
  maxTime: PropTypes.instanceOf(Date),
  onChange: PropTypes.func.isRequired,
  appData: PropTypes.objectOf(PropTypes.object)
};

const messageHeader = {
  data: PropTypes.any.isRequired,
  headerDetails: PropTypes.any.isRequired
};

const message = {
  subject: PropTypes.string.isRequired,
  latestMessage: PropTypes.string.isRequired,
  viewed: PropTypes.bool.isRequired
};

const photoPreviewButton = {
  name: PropTypes.string.isRequired,
  preview: PropTypes.string,
  previewDescription: PropTypes.string,
  invalid: PropTypes.bool,
  index: PropTypes.number,
  photosTotal: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string
};

const consenter = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  phone_number: PropTypes.string.isRequired
};

const bullet = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  color: PropTypes.string
};

const loader = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  textDelay: PropTypes.number,
  isHidden: PropTypes.bool
};

const cellWithCheck = {
  label: PropTypes.string.isRequired,
  handleControlCheck: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired
};

const textArea = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool
};

const link = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string,
  ariaLabel: PropTypes.string
};

const cancelVisit = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired
};

const invoice = {
  name: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired
};

const timeSlotPicker = {
  times: PropTypes.arrayOf(String),
  selected: PropTypes.string,
  onSelect: PropTypes.func,
  appData: PropTypes.objectOf(PropTypes.object)
};

const basicTimePicker = {
  min_hour: PropTypes.number,
  max_hour: PropTypes.number,
  delaySchedule: PropTypes.number,
  title: PropTypes.string,
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  components: PropTypes.object.isRequired
};

const creditCardLogo = {
  type: PropTypes.string.isRequired
};

const tooltip = {
  children: PropTypes.object,
  message: PropTypes.string.isRequired
};

const autocomplete = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  suggestions: PropTypes.array,
  value: PropTypes.string,
  locationField: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  onEnterDown: PropTypes.func.isRequired,
  showMagnifyingGlassIcon: PropTypes.bool,
  showCrossIcon: PropTypes.bool
};

const taskList = {
  tasks: PropTypes.array
};

const pills = {
  width: PropTypes.number,
  height: PropTypes.number,
  justify: PropTypes.string,
  options: PropTypes.array.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  invalid: PropTypes.string,
  isRadioGroup: PropTypes.bool,
  label: PropTypes.string
};

const goal = {
  items: PropTypes.array.isRequired,
  isInitiallyOpen: PropTypes.bool.isRequired,
  TaskList: PropTypes.array.isRequired
};

const gMap = {
  renderLocations: PropTypes.func.isRequired,
  center: PropTypes.array,
  children: PropTypes.any.isRequired
};

const expandoOption = {
  onCheckboxChange: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  options: PropTypes.array,
  settings: PropTypes.object
};

const dot = {
  name: PropTypes.string.isRequired
};

const customInput = {
  components: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired
};

const caseTable = {
  cases: PropTypes.array.isRequired,
  components: PropTypes.object.isRequired,
  onView: PropTypes.func.isRequired,
  settings: PropTypes.shape({
    translations: PropTypes.objectOf(PropTypes.string).isRequired
  }).isRequired
};

const caseListItem = {
  ...caseTable
};

const careTeamProvider = {
  provider: PropTypes.object.isRequired,
  onViewProfile: PropTypes.func.isRequired,
  components: PropTypes.object.isRequired
};

const chip = {
  label: PropTypes.string.isRequired,
  dismissable: PropTypes.bool,
  onlabelClick: PropTypes.func,
  onDismissClick: PropTypes.func
};

const container = {
  field: PropTypes.object,
  fieldRef: PropTypes.object,
  children: PropTypes.node,
  containerProps: PropTypes.object
};

const validationMessage = {
  children: PropTypes.node,
  isInvalid: PropTypes.bool,
  fieldName: PropTypes.string
};

const tabs = {
  variant: PropTypes.string,
  titles: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  invalid: PropTypes.bool
};

const selectWithChips = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  fieldAttributes: PropTypes.string.isRequired
};

const phonePicker = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  params: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      selected: PropTypes.bool,
      text: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      name: PropTypes.string
    })
  ),
  components: PropTypes.object.isRequired,
  isInvalid: PropTypes.bool,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  onUpdate: PropTypes.func.isRequired,
  customCountrySelect: PropTypes.bool
};

const modernizedPhoneInput = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  params: PropTypes.string,
  isInvalid: PropTypes.bool,
  onUpdate: PropTypes.func.isRequired
};

const pulseIcon = {
  field: PropTypes.shape({
    image: PropTypes.string.isRequired,
    padding: PropTypes.string,
    color: PropTypes.string,
    params: PropTypes.string,
    text: PropTypes.string
  })
};

const video = {
  field: PropTypes.shape({
    data: PropTypes.shape({
      m3u8URL: PropTypes.string.isRequired,
      splashscreenUrl: PropTypes.string.isRequired,
      accessibilityDescription: PropTypes.string.isRequired,
      playVideo: PropTypes.string.isRequired,
      accessibility_video_play: PropTypes.string.isRequired,
      subtitles: PropTypes.arrayOf(
        PropTypes.shape({
          sourceVtt: PropTypes.string.isRequired,
          languageShortName: PropTypes.string.isRequired,
          languageLongName: PropTypes.string.isRequired
        })
      )
    })
  }).isRequired
};

const modernizedButton = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
    variant: PropTypes.string.isRequired
  })
};

const modernizedRangeSlider = {
  field: PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    i18n_min_label: PropTypes.string.isRequired,
    i18n_max_label: PropTypes.string.isRequired,
    i18n_handle_labels: PropTypes.string.isRequired,
    step: PropTypes.number,
    default_values: PropTypes.number
  })
};

const audio = {
  field: PropTypes.shape({
    data: PropTypes.shape({
      url: PropTypes.string.isRequired,
      accessibilityDescription: PropTypes.string.isRequired
    })
  }).isRequired
};

const carouselControls = {
  buttonPrevClassName: PropTypes.string,
  togglePrev: PropTypes.func,
  controlsAriaPrevious: PropTypes.string,
  buttonNextClassName: PropTypes.string,
  toggleNext: PropTypes.func,
  controlsAriaNext: PropTypes.string,
  carouselCounterLabel: PropTypes.string
};

const showHideButton = {
  hidden: PropTypes.bool,
  toggleHidden: PropTypes.func,
  onShowHideEnterDown: PropTypes.func,
  className: PropTypes.string,
  isUnifiedRegistration: PropTypes.bool
};

const passwordStrength = {
  name: PropTypes.string,
  password: PropTypes.string,
  data: PropTypes.instanceOf(Object)
};

const graph = {
  graphRef: PropTypes.objectOf(PropTypes.object),
  showGrid: PropTypes.bool,
  showColumnName: PropTypes.bool,
  timeLabels: PropTypes.arrayOf(PropTypes.object),
  verticalSteps: PropTypes.arrayOf(PropTypes.object),
  graphColumns: PropTypes.arrayOf(PropTypes.object),
  graphColumnWidth: PropTypes.number,
  graphColumnHeight: PropTypes.number,
  calculateBarHeight: PropTypes.func,
  top: PropTypes.number,
  times: PropTypes.arrayOf(PropTypes.object),
  canShow: PropTypes.bool,
  dayData: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
  day: PropTypes.number,
  barHeight: PropTypes.number,
  color: PropTypes.string,
  showDivider: PropTypes.bool,
  value: PropTypes.string
};

export default {
  screen: screenPropTypes,
  address,
  autocomplete,
  button,
  fieldWrapper,
  label,
  modernizedLabel,
  select,
  text,
  textField,
  modernizedInputField,
  title,
  description,
  listItem,
  provider,
  image,
  webImage,
  slider,
  htmlText,
  input,
  switchControl,
  icon,
  expansionPanel,
  expansionMessage,
  checkbox,
  progressBar,
  messageHeader,
  datePicker,
  inlineDatePicker,
  popperDatePicker,
  timePicker,
  photoPreviewButton,
  message,
  bullet,
  loader,
  cellWithCheck,
  consenter,
  textArea,
  invoice,
  timeSlotPicker,
  basicTimePicker,
  creditCardLogo,
  tooltip,
  chip,
  container,
  taskList,
  providerControl,
  vpcpInfo,
  pills,
  goal,
  gMap,
  expandoOption,
  dot,
  customInput,
  caseTable,
  caseListItem,
  careTeamProvider,
  validationMessage,
  pulseIcon,
  phonePicker,
  audio,
  video,
  modernizedButton,
  carouselControls,
  link,
  cancelVisit,
  tabs,
  selectWithChips,
  showHideButton,
  passwordStrength,
  modernizedPhoneInput,
  modernizedRangeSlider,
  graph
};
